let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ePdrf")).then(() => parcelRequire('cAzT1'));